export default ($window, $timeout) => ({
  scope: {
    assignTo: "=",
  },
  link(scope, element, attr) {
    const $win = angular.element($window);
    // console.debug("get-prop", attr.propName, { attr, element });
    const assignTheValue = (event) => {
      const val = element.prop(attr.propName);
    //   console.info("get-prop", attr.propName, val, {
    //     val,
    //     attr,
    //     element,
    //     event,
    //   });
      scope.assignTo = val;
      scope.$apply();
      return val;
    };

    $win.bind("scroll", assignTheValue);
    element.bind("click", assignTheValue);
    element.bind("scroll", assignTheValue);
    $timeout(assignTheValue, 88);
  },
});
